import { createFileRoute } from "@tanstack/react-router"
import { PrivacyPage } from "@/routes/privacy"

export const Route = createFileRoute("/$lang/privacy")({
  component: PrivacyPage,
})
